import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {types} from 'main/tools';
import {Tooltip} from 'shared/components';

const Hours = observer(({model}) => {
  if (model._type === types.TIME_OFF.ABSENCE) {
    return <div className='pr1'>{parseFloat(model.amount)}</div>;
  }

  return (
    <div className='pr1'>
      <Tooltip
        content={model.unpaidBreakMinutes > 0 &&
          <FormattedMessage id='time_tracking.timesheet.HOURS_CALCULATION' values={{worked: model.hours, unpaid: model.unpaidBreakHours}}/>}
      >
        <div>{model.hours}</div>
        {model.unpaidBreakMinutes > 0 && <div className='h6 jumbo'>
          <FormattedMessage id='time_tracking.timesheet.UNPAID_BREAK_HOURS' values={{hours: model.unpaidBreakHours}}/>
        </div>}
      </Tooltip>
    </div>
  );
});

export default Hours;
